import { Link } from "react-router-dom";
import { Empty, Flex } from "antd";

import { SkeletonRankingsContent } from "../skeletons/home";
import { TabContent } from "../TabContent";
import { CardsWithTitle, CardsWithTitleCarousel } from "../Home/CardsWithTitle";
import useLocale from "../../hooks/useLocale";
import { __ } from "../../locales/translation";

export default function PerformanceList({ data, productType, loading }) {
    const locale = useLocale();

    const isEmpty =
    !data || !data.rankings.length || data.rankings.every((item) => !item.datos.length);

    return (
        <>
            {
                loading ? 
                <SkeletonRankingsContent />
                : isEmpty ?
                <Flex justify="center" align="center" style={{ height: "300px" }}>
                    <Empty description={__("No hay resultados")} />
                </Flex>
                :
                <>
                    <TabContent cols={data.rankings.length} classNames={"--above-895-grid --theme-dark"}>
                        {data.rankings.map((item, i) => {

                            return (
                                <CardsWithTitle
                                key={item.titulo[locale] + i}
                                title={item.titulo[locale]}
                                items={item.datos}
                                productCode={data.codigo}
                                productType={productType}
                            />
                            )
                        })}

                        <Link
                            data-external-check-exempt
                            to={`/${productType.toLowerCase()}/`}
                            className="btn btn-secondary"
                        >
                            {__("Ver más")}
                        </Link>

                        {
                            productType.toLowerCase() === "fondos" ? (
                                <Flex justify="center" align="center" vertical style={{ gridColumn: "1/-1" }}>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)", marginBottom: "8px" }}>{__("Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).")}</p>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)" }}>{__("La variacion corresponde a la ultima semana corriente")}</p>
                                </Flex>
                            ) : 
                                <Flex justify="center" align="center" style={{ gridColumn: "1/-1" }}>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)" }}>{__("Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).")}</p>
                                </Flex>
                        }
                    </TabContent>

                    <TabContent cols={1} classNames={"--below-895-flex --theme-dark"}>
                        {data.rankings.map((item, i) => {
                            return (
                                <CardsWithTitleCarousel
                                    key={item.titulo[locale] + i}
                                    title={item.titulo[locale]}
                                    items={item.datos}
                                    productCode={data.codigo}
                                    productType={productType}
                                />
                            );
                        })}

                        <Link
                            data-external-check-exempt
                            to={`/${productType.toLowerCase()}/`}
                            className="btn btn-secondary"
                        >
                            {__("Ver más")}
                        </Link>

                        {
                            productType.toLowerCase() === "fondos" ? (
                                <Flex justify="center" align="center" vertical style={{ gridColumn: "1/-1" }}>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)", marginBottom: "8px" }}>{__("Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).")}</p>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)" }}>La variacion corresponde a la ultima semana corriente</p>
                                </Flex>
                            ) : 
                                <Flex justify="center" align="center" style={{ gridColumn: "1/-1" }}>
                                    <p className="small-text" style={{ letterSpacing: "0", color: "rgba(17, 17, 17, 60%)" }}>{__("Fuente provista por BYMA y CAFCI. Los valores de cuotapartes se actualizan en forma diaria, el resto de los datos son diferidos en aproximadamente 20 minutos. Salvo Error u Omisión (SEUO).")}</p>
                                </Flex>
                        }
                    </TabContent>
                </>
            }
        </>
    );
}
